import type {
  GetMatchedQualitiesQuery,
  Maybe,
  Skill,
} from 'src/graphql/graphql.ts';

type GetMatchedQualitiesQueryQualities = NonNullable<
  NonNullable<
    NonNullable<GetMatchedQualitiesQuery>['jobDetails']
  >['personalised']
>['qualities'];
type GetMatchedQualitiesQuerySkills2 = NonNullable<
  NonNullable<GetMatchedQualitiesQuery>['viewer']
>['skills2'];

const getSkillIds = (skills: Skill[]) =>
  skills.map((s) => s.keyword?.ontologyId).filter((s) => typeof s === 'string');

export const sync = (
  qualities: GetMatchedQualitiesQueryQualities,
  skills: GetMatchedQualitiesQuerySkills2,
) => {
  if (qualities && skills) {
    const skillIds = getSkillIds(skills);

    const matched: Skill[] = [],
      inferred: Skill[] = [],
      unmatched: Skill[] = [];

    const createVerifier =
      (
        verifier: (id: string) => boolean,
        qualitiesMatchingVerfier: Skill[],
        qualitiesNotMatchingVerifer: Skill[],
      ) =>
      (quality: Maybe<Skill>) => {
        if (quality) {
          const id = quality?.keyword.ontologyId;

          const collection =
            id && verifier(id)
              ? qualitiesMatchingVerfier
              : qualitiesNotMatchingVerifer;
          collection.push(quality);
        }
      };

    qualities.matched?.forEach(
      createVerifier((id) => skillIds.includes(id), matched, unmatched),
    );
    qualities.inferred?.forEach(
      createVerifier((id) => !skillIds.includes(id), inferred, matched),
    );
    qualities.unmatched?.forEach(
      createVerifier((id) => !skillIds.includes(id), unmatched, matched),
    );

    return { matched, inferred, unmatched };
  }

  return qualities;
};
